import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * Generate a PDF from table data
 * @param {string} headerName - Title/header of the PDF
 * @param {Array} tables - Array of table objects [{ title, columns, dataSource }]
 * @param {Object} loanDetails - Additional loan details to display in the header
 */
export const generatePDF = (headerName, tables, loanDetails = null) => {
    const doc = new jsPDF();
    let startY = 15;

    doc.setFontSize(16);
    doc.setTextColor(41, 128, 185);
    doc.text(headerName, 18, startY);
    startY += 10;

    if (loanDetails) {
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);

        const details = [
            { label: "Customer", value: loanDetails.customerName },
            { label: "Account No", value: loanDetails.accNumber },
            { label: "Branch", value: loanDetails.branchName },
            { label: "Loan Type", value: loanDetails.loanType },
            { label: "Original Amount", value: loanDetails.originalAmount },
            { label: "Remaining Balance", value: loanDetails.remainingBalance },
            { label: "Total Paid", value: loanDetails.totalPaid },
            { label: "Loan Date", value: loanDetails.loanDate },
            { label: "Last Payment Date", value: loanDetails.lastPaymentDate },
        ];

        let currentX = 18;
        let currentY = startY;
        const colWidth = 90;

        details.forEach((detail, index) => {
            if (index % 2 === 0 && index !== 0) {
                currentY += 7;
                currentX = 18;
            } else if (index % 2 !== 0) {
                currentX = 18 + colWidth;
            }

            doc.setFont("helvetica", "bold");
            doc.text(`${detail.label}:`, currentX, currentY);
            doc.setFont("helvetica", "normal");
            doc.text(`${detail.value || '-'}`, currentX + (detail.label.length * 2.5) + 2, currentY);
        });

        startY = currentY + 15;
    }

    // Iterate through tables and add them to the PDF
    tables.forEach((table, tableIndex) => {
        if (table.title) {
            if (startY > doc.internal.pageSize.height - 40) {
                doc.addPage();
                startY = 20;
            }
            doc.setFontSize(12);
            doc.setTextColor(44, 62, 80);
            doc.setFont("helvetica", "bold");
            doc.text(table.title, 18, startY);
            startY += 7;
        }

        const tableColumn = table.columns.map((col) => col.title);
        const tableRows = table.dataSource.map((row, index) =>
            table.columns.map((col, colIndex) => {
                if (colIndex === 0) return index + 1;
                const value = row[col.dataIndex];
                return value !== undefined && value !== null ? value : '-';
            })
        );

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: startY,
            styles: { fontSize: 8, cellPadding: 2 },
            headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255], fontStyle: 'bold' },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            margin: { left: 18, right: 18 },
            didParseCell: (data) => {
                const rowData = data.row.raw;
                const isTotalRow = rowData.some(cell => String(cell).toLowerCase().includes('total'));

                if (data.section === "body" && isTotalRow) {
                    data.cell.styles.fontStyle = "bold";
                    data.cell.styles.fillColor = [230, 230, 230];
                }
            },
            didDrawPage: (data) => {
                startY = data.cursor.y;
            }
        });

        startY = doc.lastAutoTable.finalY + 15; 
    });

    const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(8);
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
            `Generated on: ${new Date().toLocaleString()} - Page ${i} of ${pageCount}`,
            18,
            doc.internal.pageSize.height - 10
        );
    }

    doc.save(`${headerName.replace(/\s+/g, '_')}.pdf`);
};
